import {announce} from '@github-ui/aria-live'
import {LABELS} from '@github-ui/issues-shared/labels'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import type {DeleteSavedViewVariables} from '../components/views/types'
import {
  removeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutation,
} from '../utils/saved-view-mutations'

// Drops the single-view cache for the deleted id, then invalidates the list.
export function useDeleteSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()

  return useMutation<void, Error, DeleteSavedViewVariables>({
    mutationFn: async ({id}) => {
      await sendSavedViewMutation(
        `/${owner}/${repo}/issues/views/${id}.json`,
        {method: 'DELETE'},
        LABELS.views.deleteError,
      )
    },
    onSuccess: (_data, {id}) => removeSavedViewCaches({queryClient, owner, repo}, id),
    onError: () => announce(LABELS.views.deleteError, {assertive: true}),
  })
}
